import React, { useState, useEffect } from 'react';
import { Calendar } from '@3plearning/react-components';
import moment from 'moment';
import propTypes from 'prop-types';
import classNames from 'classnames';
import TimeRangePicker from '@wojtekmaj/react-timerange-picker/dist/entry.nostyle';
import './TimeRangePicker.scss';
import { Body } from './styled';
import Checkbox from '../checkbox';

const Schedule = ({ i18n, scheduleCallBack }) => {
  moment.locale(i18n.language);
  const rangeStartDate = moment().format('YYYY-MM-DD');
  const rangeEndDate = moment().add(1, 'year').format('YYYY-MM-DD');
  const [dateSelected, setDateSelected] = useState({
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'day').format('YYYY-MM-DD')
  });
  const defaultTimeRange = [
    moment().add(15, 'minutes').format('HH:mm'),
    moment().add(15, 'minutes').format('HH:mm')
  ];
  const [timeSelected, setTimeSelected] = useState(defaultTimeRange);
  const [isScheduleEnabled, setIsScheduleEnabled] = useState('unchecked');

  const verifyValidDateTimeRange = (momentStartDate, momentEndDate) =>
    (moment.utc().add(4, 'minutes') - momentStartDate >= 0) ||
    (moment.utc().add(4, 'minutes') - momentEndDate >= 0) ||
    (momentStartDate - momentEndDate >= 0);

  useEffect(() => {
    const momentStartDate = moment(`${dateSelected.startDate} ${timeSelected[0]}`);
    const momentEndDate = moment(`${dateSelected.endDate} ${timeSelected[1]}`);

    if (isScheduleEnabled === 'checked' && verifyValidDateTimeRange(momentStartDate, momentEndDate)) {
      scheduleCallBack({
        blockAssign: true,
        isOn: true,
        dateRange: [null, null]
      });
    } else if (isScheduleEnabled === 'checked' && (momentStartDate - momentEndDate < 0)) {
      scheduleCallBack({
        blockAssign: false,
        isOn: true,
        dateRange: [momentStartDate.toISOString(), momentEndDate.toISOString()]
      });
    } else if (isScheduleEnabled === 'unchecked') {
      scheduleCallBack({
        blockAssign: false,
        isOn: false,
        dateRange: [null, null]
      });
    }
  }, [isScheduleEnabled, dateSelected, timeSelected]);

  const onDateChangeHandler = (startDate, endDate) => {
    setDateSelected({ startDate, endDate });
  };

  const onTimeChangeHandler = (newTime) => {
    if (newTime[0] && newTime[1]) {
      setTimeSelected(newTime);
    } else if (!newTime[0]) {
      newTime[0] = defaultTimeRange[0];
      setTimeSelected(newTime);
    } else if (!newTime[1]) {
      newTime[1] = defaultTimeRange[1];
      setTimeSelected(newTime);
    }
  };

  const onDatesChange = ({ startDate, endDate }) => {
    onDateChangeHandler(
      startDate.format('YYYY-MM-DD'),
      (startDate - endDate >= 0 ? moment(startDate).add(1, 'day') : endDate).format('YYYY-MM-DD')
    );
  };

  const defaultProps = {
    range: { startDate: rangeStartDate, endDate: rangeEndDate },
    weeklyRangeOnly: false,
    onDatesPicked: () => {},
    onClose: () => {},
    reactDatesConfig: {
      startDatePlaceholderText: i18n.t`Start date`,
      endDatePlaceholderText: i18n.t`End date`,
      startDate: moment(dateSelected.startDate),
      endDate: moment(dateSelected.endDate),
      onDatesChange
    }
  };

  return (
    <Body>
      <Checkbox
        checkboxHandler={cbStatus => setIsScheduleEnabled(cbStatus)}
        state={isScheduleEnabled}
        name="isScheduleEnabled">
        <span className="text">{i18n.t`Schedule assessment period`}</span>
      </Checkbox>
      <div
        className={classNames(isScheduleEnabled === 'checked' ? 'show' : 'hide', 'calendar')}
      >
        <Calendar {...defaultProps} />
        <TimeRangePicker
          onChange={onTimeChangeHandler}
          value={timeSelected}
          format="h:mm a"
          disableClock
          clearIcon={null}
          required
        />
      </div>
    </Body>
  );
};

Schedule.propTypes = {
  i18n: propTypes.object,
  scheduleCallBack: propTypes.func
};

export default Schedule;
